<template>
  <SpForm class="content_part-nav-setting" ref='form' v-model="localValue" suffix="" :formList='navFormList'
    :submit='false' labelWidth='80px' />
</template>

<script>
import CompsStyle from "../../comps/comps-style.vue";
import CompHotPicker from '../../comps/comp-hotpicker'
import SvgFilePicker from './svg-file-picker.vue'


export default {
  name: "nav-setting",
  props: {
    value: {
      type: Object,
      default: () => { }
    },
    immersiveSwitch: {
      type: Number,
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localValue: {},
    }
  },
  methods: {},
  computed: {
    navFormList() {
      const { navbgtype } = this.localValue
      return [
        {
          label: '导航栏背景',
          key: "navbgtype",
          type: 'radio-button',
          options: [
            { name: "背景颜色", label: '0' },
            { name: "背景图片", label: '1' },
          ],
        },
        {
          label: `导航栏底色${this.immersiveSwitch == 1 ? '(默认)' : ''}`,
          key: "navbgcolor",
          type: 'color',
          isShow: () => {
            return navbgtype == 0
          }
        },
        {
          label: `导航栏底色（滑动后）`,
          key: "navbgslidervalue",
          type: 'color',
          isShow: () => {
            return navbgtype == 0 && this.immersiveSwitch == 1
          }
        },
        {
          label: `导航栏背景图${this.immersiveSwitch == 1 ? '(默认)' : ''}`,
          key: "imgUrl",
          component: ({ key }) => {
            return <SpImagePicker v-model={this.localValue[key]} />
          },
          isShow: () => {
            return navbgtype == 1
          }
        },
        {
          label: `导航栏背景图（滑动后）`,
          key: "imgUrlslider",
          component: ({ key }) => {
            return <SpImagePicker v-model={this.localValue[key]} />
          },
          isShow: () => {
            return navbgtype == 1 && this.immersiveSwitch == 1
          }
        },
        {
          label: '导航栏内边距',
          key: "navpadded",
          component: ({ key }) => {
            return <CompsStyle
              showBgsetting={false}
              v-model={this.localValue[key]}
              showLabel={false}
              uuid={`${this.uuid}_${key}`}
            />
          },
        },
        {
          label: '滑动后颜色模式',
          key: "immersiveSwitchColorMode",
          type: 'radio-button',
          options: [
            { name: "浅色", label: 'light' },
            { name: "深色", label: 'dark' },
          ],
          isShow: () => {
            return this.immersiveSwitch == 1
          },
        },
        {
          label: '背景色透明度(0-1)',
          key: "navbgopacity",
          type: "number",
          position: "right",
          min: 0,
          max: 1,
          size: "mini",
          isShow: () => {
            return this.immersiveSwitch == 1
          }
        },
        {
          label: '导航顶部svg图源码',
          key: "topimgUrlSvg",
          component: ({ key }) => {
            return <SvgFilePicker v-model={this.localValue[key]} />
          },
          isShow: () => {
            return this.immersiveSwitch == 1
          },
        },
        {
          label: '导航顶部点击跳转配置',
          key: "navitemjumpconfig",
          component: ({ key }) => {
            return <CompHotPicker v-model={this.localValue[key]} isShowH5Link={false} />
          },
          isShow: () => {
            return this.immersiveSwitch == 1
          },
        },
        {
          label: '导航顶部搜索svg图源码',
          key: "topimgUrlSvgSearch",
          component: ({ key }) => {
            return <SvgFilePicker v-model={this.localValue[key]} />
          },
          isShow: () => {
            return this.immersiveSwitch == 1
          },
        },
        {
          label: '导航顶部搜索点击跳转',
          key: "navitemjumpconfigSearch",
          component: ({ key }) => {
            return <CompHotPicker v-model={this.localValue[key]} isShowH5Link={false} />
          },
          isShow: () => {
            return this.immersiveSwitch == 1
          },
        },
        {
          label: '导航项文本字号',
          key: "navitemtextfontsize",
          type: "number",
          position: "right",
          min: 12,
          size: "mini",
          isShow: () => {
            return false
          }
        },
        {
          label: '导航项文本选中加粗值',
          key: "navitemtextboldvalue",
          type: "number",
          position: "right",
          min: 100,
          max: 900,
          size: "mini",
          isShow: () => {
            return false
          }
        },
        {
          label: "导航形式",
          key: "navtype",
          type: "radio-button",
          options: [
            { name: "叠加滚动", label: '0' },
            { name: "通栏等分", label: '1' },
          ],
        },
        {
          label: "导航项区域底色",
          key: "navitemcolor",
          type: 'color',
        },
        {
          label: "导航项区域底色（滑动后）",
          key: "navitemcolorSlider",
          type: 'color',
          isShow: () => {
            return this.immersiveSwitch == 1
          },
        },
        {
          label: '导航项区域内边距',
          key: "navitemareapadded",
          component: ({ key }) => {
            return <CompsStyle
              showBgsetting={false}
              v-model={this.localValue[key]}
              showLabel={false}
              uuid={`${this.uuid}_${key}`}
            />
          },
        },
       // {
        //  label: '导航项内边距',
        //  key: "navitempadded",
        //  component: ({ key }) => {
         //   return <CompsStyle
           //   showBgsetting={false}
         //     v-model={this.localValue[key]}
           //   showLabel={false}
           //   uuid={`${this.uuid}_${key}`}
          //  />
          //},
        //},
        {
          label: "导航项高度",
          key: "navitemHeight",
          type: "number",
          position: "right",
          min: 24,
          size: "mini",
        },
        {
          label: "导航项圆角",
          key: "navitemradius",
          type: "number",
          position: "right",
          min: 0,
          size: "mini",
        }, {
          label: "轮播项内边距",
          key: "slideritempadded",
          component: ({ key }) => {
            return (
              <CompsStyle
                v-model={this.localValue[key]}
                showTop={false}
                showLeft={false}
                showBottom={false}
                showRight={false}
                showBgsetting={false}
                showLabel={false}
                showTB={true}
                showLR={true}
                uuid={`${this.uuid}_${key}`}
              />
            );
          },
        }, {
          label: "导航左滑示意图",
          key: "leftimgUrl",
          component: ({ key }) => {
            return <div class={"sp-image-picker"}><SpImagePicker v-model={this.localValue[key]} size="small" /></div>
          },
        },
        {
          label: "导航右滑示意图",
          key: "rightimgUrl",
          component: ({ key }) => {
            return <div class={"sp-image-picker"}><SpImagePicker v-model={this.localValue[key]} size="small" /></div>
          }
        },
      ]
    }
  },
  watch: {
    uuid: {
      handler() {
        this.localValue = this.value;
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
<style lang="scss">
.content_part-nav-setting {
  margin-top: 10px;
  margin-left: -80px;

  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item__label {
    text-align: left;
    color: #888;
    padding: 0px;
    line-height: normal;
    margin-top: 5px;
  }

  .sp-image-picker {
    position: relative;

    .el-icon-circle-close {
      position: absolute;
      top: -5px;
      left: 56px;
      cursor: pointer;
    }
  }
}
</style>
